import type { MenuItemProps } from '@terra/ui-design-system';

export function buildDiscoveryMenuItems({
  isAiApplication,
  isBackendOnly,
  isSourceCodeConnected,
  showDirectoryScan,
  showDeepSecurityScan,
  labels,
  onSelectAiDiscovery,
  onSelectCrawler,
  onSelectDirectoryScan,
  onSelectDeepSecurityScan,
}: {
  isAiApplication: boolean;
  isBackendOnly?: boolean;
  isSourceCodeConnected?: boolean;
  showDirectoryScan: boolean;
  showDeepSecurityScan: boolean;
  labels: {
    aiDiscovery: string;
    crawler: string;
    directoryScan: string;
    deepSecurityScan: string;
  };
  onSelectAiDiscovery: () => void;
  onSelectCrawler: () => void;
  onSelectDirectoryScan: () => void;
  onSelectDeepSecurityScan: () => void;
}): MenuItemProps[] {
  if (isAiApplication) {
    return [
      {
        value: 'ai-discovery',
        label: labels.aiDiscovery,
        onClick: onSelectAiDiscovery,
      },
    ];
  }

  const items: MenuItemProps[] = [
    {
      value: 'crawler',
      label: labels.crawler,
      onClick: onSelectCrawler,
      disabled: !!isBackendOnly,
    },
  ];

  if (showDirectoryScan) {
    items.push({
      value: 'directory-scan',
      label: labels.directoryScan,
      onClick: onSelectDirectoryScan,
      disabled: !!isBackendOnly,
    });
  }

  if (showDeepSecurityScan) {
    items.push({
      value: 'deep-security-scan',
      label: labels.deepSecurityScan,
      onClick: onSelectDeepSecurityScan,
      disabled: isSourceCodeConnected === false,
    });
  }

  return items;
}
